import { createI18nInstance } from './utils';
import du from './du/translation.json';
import en from './en/translation.json';

export const { i18n, t } = createI18nInstance({ en, du });
